/** @format */

import {ReactNode} from 'react';

import {Box} from '@mui/material';
import {Trans} from 'react-i18next';
import {useTheme} from '@mui/material/styles';

interface Props {
  title: ReactNode;
  plan: string;
}

const KpiHead = ({title, plan}: Props) => {
  const theme = useTheme();

  return (
    <>
      <Box sx={{display: 'flex', flexDirection: 'column'}} component='span' data-testid='kpi-head'>
        <Box
          component='span'
          sx={{
            color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
            fontSize: '12px',
            lineHeight: '14px',
            letterSpacing: '0.24px',
          }}
        >
          KPI
        </Box>
        <Box component='span'>{title}</Box>
      </Box>
      <Box sx={{display: 'flex', gap: '4px', mt: 3}} component='span'>
        <Box component='span' sx={{fontWeight: 400, fontSize: '14px'}}>
          <Trans>План</Trans>:
        </Box>
        <Box component='span' sx={{fontSize: '14px'}}>
          {plan}
        </Box>
      </Box>
    </>
  );
};

export {KpiHead};
